import { render } from "./ReportChoices.vue?vue&type=template&id=3d85794a&scoped=true"
import script from "./ReportChoices.vue?vue&type=script&lang=js"
export * from "./ReportChoices.vue?vue&type=script&lang=js"

import "./inventoryReport.css?vue&type=style&index=0&id=3d85794a&scoped=true&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d85794a"]])

export default __exports__